import './missionEdit.less';
import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { CalendarPosition, getCalendarPosition } from '../misc/calendarPosition';

angular.module("tromanWeb").controller('MissionEditController', ['$q', 'DialogControllerBase', '$scope', 'tromanServer', 'ObjectCache', 'organizationService', 'tromanGlobals', 'mission', 'existingMissionsToCheck', function ($q, DialogControllerBase, $scope, tromanServer, ObjectCache, organizationService, tromanGlobals, mission, existingMissionsToCheck) {

    DialogControllerBase.call(this, tromanServer.Missions, $scope);

    this.isPolitikerEnabled = tromanGlobals.systemInfo.IsPolitikerEnabled;

    this.getItem = function () { return this.mission; };
    this.getTitle = function () {
        if (this.mission == null) return '';

        var p = this.mission.Person;
        var o = this.mission.MandatePeriod && this.mission.MandatePeriod.Organization;
        if (o == null) return '';

        return 'uppdraget för "' + (p ? p.name : 'Vakant') + '" i "' + o.Name + '"';
    };

    this.personChanged = function () {
        setFieldsFromPerson(this.mission);
        this.matchingMission = findMatchingMission(this.mission, this.existingMissions);
        this._updatePublishHints();
    };

    this.organizationChanged = function () {
        this.mission.MandatePeriod = organizationService.selectDisplayMandate(this.selectedOrganization);
        this.mandatePeriodChanged();
        this._updatePublishHints();
    };

    this.mandatePeriodChanged = function () {
        setDatesFromMandate(this.mission);
        mandatePeriodOrMissionTypeChanged(this.mission);

        if (mission.Id == null) {
            if (mission.MandatePeriod) {
                mission.AllowPolitikerRegistration = mission.MandatePeriod.Organization.AllowPolitikerRegistration;
                mission.EnableMunicipalityCheck = !_.isEmpty(mission.MandatePeriod.Organization.ValidMunicipalities);
            }
        }

        this.mission.Substitutes = [];
        this._reloadSubstitutes();
        this.matchingMission = findMatchingMission(this.mission, this.existingMissions);
    };

    this.missionTypeChanged = function () {
        mandatePeriodOrMissionTypeChanged(this.mission);

        if (!(this.mission.MissionType && !this.mission.MissionType.IsSubstitute)) {
            this.mission.Substitutes = [];
        }
        this._reloadSubstitutes();
        this._updatePublishHints();
    };

    this.missionDateChanged = function () {
        this._updatePublishHints();
    };

    this.updatePublishHints = function () {
        this._updatePublishHints();
    };

    this.isValidMunicipality = function () {
        if (!this.mission) return true;
        if (!this.mission.EnableMunicipalityCheck) return true;
        if (!this.mission.Person) return true;
        if (!this.mission.MandatePeriod) return true;

        return utility.isValidMunicipality(this.mission.Person.MunicipalityCode, this.mission.MandatePeriod.Organization.ValidMunicipalities);
    };

    function mandatePeriodOrMissionTypeChanged(mission) {
        if (mission.Id == null) {
            if (mission.MandatePeriod && mission.MissionType) {
                mission.IsGroundForGratuity = mission.MandatePeriod.IsGroundForGratuity && mission.MissionType.IsGroundForGratuity;
            }
        }
    }

    function setFieldsFromPerson(mission) {
        if (mission.Person) {
            mission.Party = mission.Person.Party;
            mission.HasMeetingPay = !!mission.Person.HasMeetingPay;
        } else {
            mission.Party = null;
            mission.HasMeetingPay = false;
        }
    }

    function setDatesFromMandate(mission) {
        if (mission.MandatePeriod) {
            if (getCalendarPosition(mission.MandatePeriod.Start, mission.MandatePeriod.End) === CalendarPosition.Future) {
                mission.Start = angular.copy(mission.MandatePeriod.Start);
            }
            mission.End = angular.copy(mission.MandatePeriod.End);
        }
    }

    function findMatchingMission(mission, existing) {
        if (mission == null) return null;
        if (existing == null) return null;
        if (mission.Person == null) return null;
        if (mission.MandatePeriod == null) return null;

        var matching = _.filter(existing, x => x.PersonId == mission.Person.Id && x.MandatePeriodId == mission.MandatePeriod.Id);
        if (matching.length == 0) {
            return null;
        }

        return _.orderBy(matching, [x => x.End?.getTime() ?? Number.MAX_SAFE_INTEGER, x => x.Start.getTime()], ['desc', 'desc'])[0];
    }

    this._reloadSubstitutes = function () {
        this.substitutes = [];
        loadSubstitutes(this.mission)
            .then(subs => {
                this.substitutes = subs;
            })
            .catch(err => this.showError(err));
    };

    this._updatePublishHints = function () {
        if (this.mission.EnablePublish) {
            this.showPersonPublishHint = this.mission.Person?.Publish?.DisablePublish;
            this.showMissionTypePublishHint = this.mission.MissionType && !this.mission.MissionType.EnablePublish;
            this.showOrganizationPublishHint = this.mission.MandatePeriod?.Organization && (!this.mission.MandatePeriod.Organization.Publish || !this.mission.MandatePeriod.Organization.Publish.EnablePublish);
            const missionIsHistoric = getCalendarPosition(this.mission.Start, this.mission.End) === CalendarPosition.Historic;
            this.showHistoryPublishHint = missionIsHistoric && this.mission.MandatePeriod.Organization && !this.mission.MandatePeriod.Organization.ShowHistory;
        }
        else {
            this.showPersonPublishHint = false;
            this.showOrganizationPublishHint = false;
            this.showMissionTypePublishHint = false;
            this.showHistoryPublishHint = false;
        }
    };

    function loadSubstitutes(mission) {
        if (!mission)
            return $q.when(null);
        if (!mission.MandatePeriod)
            return $q.when(null);
        if (!mission.MandatePeriod.Id)
            return $q.when(null);
        if (!mission.MandatePeriod.HasPersonalSubstitutes)
            return $q.when(null);
        if (!mission.MissionType)
            return $q.when(null);
        if (mission.MissionType.IsSubstitute)
            return $q.when(null);

        return ObjectCache.getPersons(mission.Substitutes, { IsSubstituteInMandatePeriodId: mission.MandatePeriod.Id });
    }

    function loadRelated(mission) {
        var state = {};

        state.mission = mission;
        state.enableMandatePeriod = mission.Id == null && mission.MandatePeriod == null;
        state.enablePerson = mission.Person == null;

        if (mission.Id == null) {
            setDatesFromMandate(mission);
            setFieldsFromPerson(mission);
            // All new missions are published by default
            mission.EnablePublish = true;
        }

        if (existingMissionsToCheck != null) {
            if (state.enableMandatePeriod || state.enablePerson) {
                state.existingMissions = existingMissionsToCheck;
            }
        } else if (state.enableMandatePeriod && mission.Person?.Id != null) {
            state.existingMissions = tromanServer.Missions.search({
                PersonId: mission.Person.Id
            });
        } else if (state.enablePerson && mission.MandatePeriod?.Id != null) {
            // This path is currently never taken
            state.existingMissions = tromanServer.Missions.search({
                MandatePeriodId: mission.MandatePeriod.Id,
            });
        }

        state.parties = ObjectCache.getParties(mission.Party);
        state.divisions = ObjectCache.getDivisions(mission.Divisions);
        state.missionTypes = ObjectCache.getMissionTypes(mission.MissionType);
        state.substitutes = loadSubstitutes(mission);

        if (state.enableMandatePeriod) {
            state.organizations = ObjectCache.getOrganizations();
        }

        if (state.enablePerson) {
            state.persons = ObjectCache.getPersons();
        }

        return $q.all(state);
    }

    this.$onInit = function () {
        this.loadItem(mission)
            .then(loadRelated)
            .then(state => {
                _.extend(this, state);
                this.selectedOrganization = this.mission.MandatePeriod && this.mission.MandatePeriod.Organization;
                this._updatePublishHints();
            })
            .catch(err => this.showError(err));
    };

}]);
